import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from '../api/axios';
import { API_ENDPOINTS } from "../api/endpoint";
import { toast } from 'react-toastify';
import i18n from "i18next";  // Importing i18n for translations
import { logDOM } from "@testing-library/react";

const initialState = {
    pokemons: [],
    characters: [],
    player_pokemons: [],
    pokemon: {},
    pokemons_by_player: [],
    all_pokemons: [], // All pokemons (team + box)
    admin_users: [],
    admin_user_pokemons: [],
    admin_users_loading: false,
    admin_user_pokemons_loading: false,
    // Attacks management
    all_attacks: [],
    all_attacks_loading: false,
    update_attacks_loading: false,
    pokemon_attacks: [],
    pokemon_attacks_loading: false,
    pokemon_attack_types: [],
    save_attack_loading: false,
    // Evolution management
    pokemon_evolutions: [],
    pokemon_evolutions_loading: false,
    save_evolution_loading: false
};

export const getPokemons = createAsyncThunk('auth/getPokemons', async (_, { rejectWithValue }) => {
    return axios({
        url: `${API_ENDPOINTS.POKEMONS}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(response => response.data)
        .catch(error => {
            toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')
        });
});

export const adminGetAllPokemons = createAsyncThunk('pokemon/adminGetAllPokemons', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(API_ENDPOINTS.ADMIN_GET_ALL_POKEMONS);
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to load all pokemons!');
        return rejectWithValue(error.response?.data);
    }
});
export const getPlayerPokemons = createAsyncThunk('auth/getPlayerPokemons', async (_, { rejectWithValue }) => {
    try {

        return axios({
            url: `${API_ENDPOINTS.PLAYER_POKEMONS}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.data)
            .catch(error => {
                toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')


                // return rejectWithValue(error.response.data);
            });
    }

    catch (error) {

    }
});
export const getPokemonsByPlayer = createAsyncThunk('auth/getPokemonsByPlayer', async (data, { rejectWithValue }) => {
    try {
        if (data) {

            return axios({
                url: `${API_ENDPOINTS.PLAYER_POKEMONS_BY_PLAYER}`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: {
                    playerName: data
                }
            })
                .then(response => response.data)
                .catch(error => {
                    toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')
                });
        }
    }

    catch (error) {

    }
});
export const getPokemonProfileById = createAsyncThunk('auth/getPokemonProfileById', async (id, { rejectWithValue }) => {
    try {

        return axios({
            url: `${API_ENDPOINTS.POKEMON_BY_ID}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                id: id
            }
        })
            .then(response => response.data)
            .catch(error => {
                toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')


                // return rejectWithValue(error.response.data);
            });
    }

    catch (error) {

    }
});

export const getCharacters = createAsyncThunk('auth/getCharacters', async (userCredentials, { rejectWithValue }) => {

    return await axios({
        url: API_ENDPOINTS.GET_CHARACTERS,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(response => response.data)
        .catch(error => {
            toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')

            // return rejectWithValue(error.response.data);
        });
});
export const addPlayerPokemon = createAsyncThunk('auth/addPlayerPokemon', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios({
                url: API_ENDPOINTS.ADD_PLAYER_POKEMON,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                data: {
                    pokemon_id: data
                }
            }), {
            pending: i18n.t('Player updating...'),
            success: i18n.t('Player update!'),
            error: {
                render({ data }) {
                    return data?.response?.data?.message || i18n.t('failed!');
                }
            }
        }
        )
        return response.data
    } catch (error) {
        toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')

    }
});

export const getAllPlayerPokemons = createAsyncThunk('auth/getAllPlayerPokemons', async (_, { rejectWithValue }) => {
    try {
        return axios({
            url: `${API_ENDPOINTS.GET_ALL_PLAYER_POKEMONS}`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.data)
            .catch(error => {
                toast.error((error?.response?.data?.message || error?.response?.data?.error) || 'failed!')
            });
    } catch (error) {
        // return rejectWithValue(error.response.data);
    }
});

export const adminGivePokemon = createAsyncThunk('pokemon/adminGivePokemon', async ({ target_username, pokemon_id, level, add_to_team }, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_GIVE_POKEMON, { 
                target_username, 
                pokemon_id, 
                level: level || 5,
                add_to_team: add_to_team || false
            }),
            {
                pending: 'Giving Pokemon...',
                success: 'Pokemon given successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || data?.response?.data?.error || 'Failed to give Pokemon!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

export const adminGetAllUsers = createAsyncThunk('pokemon/adminGetAllUsers', async ({ page = 1, limit = 50, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axios.get(API_ENDPOINTS.ADMIN_GET_ALL_USERS, {
            params: { page, limit, search }
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to load users!');
        return rejectWithValue(error.response?.data);
    }
});

export const adminGetUserPokemons = createAsyncThunk('pokemon/adminGetUserPokemons', async (username, { rejectWithValue }) => {
    try {
        const response = await axios.post(API_ENDPOINTS.ADMIN_GET_USER_POKEMONS, { username });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to load user pokemons!');
        return rejectWithValue(error.response?.data);
    }
});

export const adminTakePokemon = createAsyncThunk('pokemon/adminTakePokemon', async (pokemonId, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_TAKE_POKEMON, { pokemon_id: pokemonId }),
            {
                pending: 'Removing Pokemon...',
                success: 'Pokemon removed successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to remove Pokemon!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

export const adminEditUser = createAsyncThunk('pokemon/adminEditUser', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_EDIT_USER, data),
            {
                pending: 'Updating user...',
                success: 'User updated successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to update user!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

export const adminAddPokemonToDB = createAsyncThunk('pokemon/adminAddPokemonToDB', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_ADD_POKEMON_TO_DB, data),
            {
                pending: 'Adding Pokemon to database...',
                success: 'Pokemon added successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to add Pokemon!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

export const adminEditPokemonInDB = createAsyncThunk('pokemon/adminEditPokemonInDB', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_EDIT_POKEMON_IN_DB, data),
            {
                pending: 'Updating Pokemon...',
                success: 'Pokemon updated successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to update Pokemon!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

// Admin: Get all attacks
export const adminGetAllAttacks = createAsyncThunk('pokemon/adminGetAllAttacks', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(API_ENDPOINTS.ADMIN_GET_ALL_ATTACKS);
        return response.data;
    } catch (error) {
        console.error('Failed to load attacks:', error);
        return rejectWithValue(error.response?.data);
    }
});

// Admin: Update Pokemon attacks
export const adminUpdatePokemonAttacks = createAsyncThunk('pokemon/adminUpdatePokemonAttacks', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_UPDATE_POKEMON_ATTACKS, data),
            {
                pending: 'Updating Pokemon attacks...',
                success: 'Attacks updated successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to update attacks!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

// Admin: Get Pokemon attacks with levels
export const adminGetPokemonAttacks = createAsyncThunk('pokemon/adminGetPokemonAttacks', async (wildId, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${API_ENDPOINTS.ADMIN_GET_POKEMON_ATTACKS}?wild_id=${wildId}`);
        return response.data;
    } catch (error) {
        console.error('Failed to load pokemon attacks:', error);
        return rejectWithValue(error.response?.data);
    }
});

// Admin: Save Pokemon attack
export const adminSavePokemonAttack = createAsyncThunk('pokemon/adminSavePokemonAttack', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_SAVE_POKEMON_ATTACK, data),
            {
                pending: 'Saving attack...',
                success: 'Attack saved successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to save attack!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

// Admin: Get Pokemon evolutions
export const adminGetPokemonEvolutions = createAsyncThunk('pokemon/adminGetPokemonEvolutions', async (wildId, { rejectWithValue }) => {
    try {
        const response = await axios.post(API_ENDPOINTS.ADMIN_GET_POKEMON_EVOLUTIONS, { wild_id: wildId });
        return response.data;
    } catch (error) {
        console.error('Failed to load pokemon evolutions:', error);
        return rejectWithValue(error.response?.data);
    }
});

// Admin: Save Pokemon evolution
export const adminSavePokemonEvolution = createAsyncThunk('pokemon/adminSavePokemonEvolution', async (data, { rejectWithValue }) => {
    try {
        const response = await toast.promise(
            axios.post(API_ENDPOINTS.ADMIN_SAVE_POKEMON_EVOLUTION, data),
            {
                pending: 'Saving evolution...',
                success: 'Evolution saved successfully!',
                error: {
                    render({ data }) {
                        return data?.response?.data?.message || 'Failed to save evolution!';
                    }
                }
            }
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data);
    }
});

export const updatePokemonTeam = createAsyncThunk('auth/updatePokemonTeam', async (data, { rejectWithValue }) => {
    try {
        const response = await axios({
            url: API_ENDPOINTS.UPDATE_POKEMON_TEAM,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            data: {
                pokemon_id: data.pokemon_id,
                action: data.action // 'add' or 'remove'
            }
        });
        if (response.data.success) {
            toast.success(response.data.message || 'Team updated successfully!');
        }
        return response.data;
    } catch (error) {
        const errorMessage = error?.response?.data?.error || error?.response?.data?.message || 'Failed to update team!';
        toast.error(errorMessage);
        return rejectWithValue(errorMessage);
    }
});

export const pokemonSlice = createSlice({
    name: 'pokemon',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPokemons.pending, (state) => {
                state.pokemons_loading = true;
                state.pokemons_error = null;
            })
            .addCase(getPokemons.fulfilled, (state, action) => {
                state.pokemons_loading = false;
                state.pokemons = action.payload?.available_pokes;
            })
            .addCase(getPokemons.rejected, (state, action) => {
                state.pokemons_loading = false;
                state.pokemons_error = action.payload;
            })
            .addCase(getPokemonProfileById.pending, (state) => {
                state.pokemon_loading = true;
                state.pokemon_error = null;
            })
            .addCase(getPokemonProfileById.fulfilled, (state, action) => {
                state.pokemon_loading = false;
                state.pokemon = action.payload?.data[0];
            })
            .addCase(getPokemonProfileById.rejected, (state, action) => {
                state.pokemon_loading = false;
                state.pokemon_error = action.payload;
            })
            .addCase(getCharacters.pending, (state) => {
                state.characters_loading = true;
                state.error = null;
            })
            .addCase(getCharacters.fulfilled, (state, action) => {
                state.characters_loading = false;
                state.characters = action.payload;
            })
            .addCase(getCharacters.rejected, (state, action) => {
                state.characters_loading = false;
                state.characters_error = action.payload;
            })
            .addCase(getPlayerPokemons.pending, (state) => {
                state.player_pokemons_loading = true;
                state.player_pokemons_error = null;
            })
            .addCase(getPlayerPokemons.fulfilled, (state, action) => {
                state.player_pokemons_loading = false;
                // Now getPlayerPokemons returns ALL Pokemon (team + box), not just team
                state.player_pokemons = Array.isArray(action.payload) ? action.payload : [];
                // Also update all_pokemons with all pokemons (team + box)
                if (Array.isArray(action.payload)) {
                    state.all_pokemons = action.payload;
                }
            })
            .addCase(getPlayerPokemons.rejected, (state, action) => {
                state.player_pokemons_loading = false;
                state.player_pokemons_error = action.payload;
            })
            .addCase(addPlayerPokemon.pending, (state) => {
                state.add_player_pokemons_loading = true;
                state.add_player_pokemons_error = null;
            })
            .addCase(addPlayerPokemon.fulfilled, (state, action) => {
                state.add_player_pokemons_loading = false;
            })
            .addCase(addPlayerPokemon.rejected, (state, action) => {
                state.add_player_pokemons_loading = false;
                state.add_player_pokemons_error = action.payload;
            })
            .addCase(updatePokemonTeam.pending, (state) => {
                state.update_team_loading = true;
                state.update_team_error = null;
            })
            .addCase(updatePokemonTeam.fulfilled, (state, action) => {
                state.update_team_loading = false;
            })
            .addCase(updatePokemonTeam.rejected, (state, action) => {
                state.update_team_loading = false;
                state.update_team_error = action.payload;
            })
            .addCase(getPokemonsByPlayer.fulfilled, (state, action) => {
                state.pokemons_by_player = action.payload;
            })
            .addCase(getAllPlayerPokemons.pending, (state) => {
                state.all_pokemons_loading = true;
                state.all_pokemons_error = null;
            })
            .addCase(getAllPlayerPokemons.fulfilled, (state, action) => {
                state.all_pokemons_loading = false;
                state.all_pokemons = action.payload || [];
            })
            .addCase(getAllPlayerPokemons.rejected, (state, action) => {
                state.all_pokemons_loading = false;
                state.all_pokemons_error = action.payload;
            })
            .addCase(adminGivePokemon.pending, (state) => {
                state.admin_give_pokemon_loading = true;
                state.admin_give_pokemon_error = null;
            })
            .addCase(adminGivePokemon.fulfilled, (state, action) => {
                state.admin_give_pokemon_loading = false;
            })
            .addCase(adminGivePokemon.rejected, (state, action) => {
                state.admin_give_pokemon_loading = false;
                state.admin_give_pokemon_error = action.payload;
            })
            .addCase(adminGetAllUsers.pending, (state) => {
                state.admin_users_loading = true;
            })
            .addCase(adminGetAllUsers.fulfilled, (state, action) => {
                state.admin_users_loading = false;
                state.admin_users = action.payload?.users || [];
            })
            .addCase(adminGetAllUsers.rejected, (state, action) => {
                state.admin_users_loading = false;
            })
            .addCase(adminGetUserPokemons.pending, (state) => {
                state.admin_user_pokemons_loading = true;
            })
            .addCase(adminGetUserPokemons.fulfilled, (state, action) => {
                state.admin_user_pokemons_loading = false;
                state.admin_user_pokemons = action.payload?.pokemons || [];
            })
            .addCase(adminGetUserPokemons.rejected, (state, action) => {
                state.admin_user_pokemons_loading = false;
            })
            .addCase(adminTakePokemon.fulfilled, (state, action) => {
                // Remove pokemon from admin_user_pokemons if it exists
                state.admin_user_pokemons = state.admin_user_pokemons.filter(p => p.id !== action.meta.arg);
            })
            .addCase(adminGetAllPokemons.pending, (state) => {
                state.pokemons_loading = true;
                state.pokemons_error = null;
            })
            .addCase(adminGetAllPokemons.fulfilled, (state, action) => {
                state.pokemons_loading = false;
                // Store all pokemons directly (not in available_pokes structure)
                state.pokemons = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(adminGetAllPokemons.rejected, (state, action) => {
                state.pokemons_loading = false;
                state.pokemons_error = action.payload;
            })
            // Admin: Get all attacks
            .addCase(adminGetAllAttacks.pending, (state) => {
                state.all_attacks_loading = true;
            })
            .addCase(adminGetAllAttacks.fulfilled, (state, action) => {
                state.all_attacks_loading = false;
                state.all_attacks = action.payload?.attacks || [];
            })
            .addCase(adminGetAllAttacks.rejected, (state) => {
                state.all_attacks_loading = false;
            })
            // Admin: Update Pokemon attacks
            .addCase(adminUpdatePokemonAttacks.pending, (state) => {
                state.update_attacks_loading = true;
            })
            .addCase(adminUpdatePokemonAttacks.fulfilled, (state, action) => {
                state.update_attacks_loading = false;
                // Update the pokemon in the list with new attacks
                if (action.payload?.success && action.meta.arg) {
                    const pokemonIndex = state.pokemons.findIndex(p => p.wild_id === action.meta.arg.wild_id);
                    if (pokemonIndex !== -1) {
                        state.pokemons[pokemonIndex] = {
                            ...state.pokemons[pokemonIndex],
                            ...action.payload.attacks
                        };
                    }
                }
            })
            .addCase(adminUpdatePokemonAttacks.rejected, (state) => {
                state.update_attacks_loading = false;
            })
            // Admin: Get Pokemon attacks with levels
            .addCase(adminGetPokemonAttacks.pending, (state) => {
                state.pokemon_attacks_loading = true;
            })
            .addCase(adminGetPokemonAttacks.fulfilled, (state, action) => {
                state.pokemon_attacks_loading = false;
                state.pokemon_attacks = action.payload?.attacks || [];
                state.pokemon_attack_types = action.payload?.available_types || [];
            })
            .addCase(adminGetPokemonAttacks.rejected, (state) => {
                state.pokemon_attacks_loading = false;
            })
            // Admin: Save Pokemon attack
            .addCase(adminSavePokemonAttack.pending, (state) => {
                state.save_attack_loading = true;
            })
            .addCase(adminSavePokemonAttack.fulfilled, (state) => {
                state.save_attack_loading = false;
            })
            .addCase(adminSavePokemonAttack.rejected, (state) => {
                state.save_attack_loading = false;
            })
            // Admin: Get Pokemon evolutions
            .addCase(adminGetPokemonEvolutions.pending, (state) => {
                state.pokemon_evolutions_loading = true;
            })
            .addCase(adminGetPokemonEvolutions.fulfilled, (state, action) => {
                state.pokemon_evolutions_loading = false;
                state.pokemon_evolutions = action.payload?.evolutions || [];
            })
            .addCase(adminGetPokemonEvolutions.rejected, (state) => {
                state.pokemon_evolutions_loading = false;
            })
            // Admin: Save Pokemon evolution
            .addCase(adminSavePokemonEvolution.pending, (state) => {
                state.save_evolution_loading = true;
            })
            .addCase(adminSavePokemonEvolution.fulfilled, (state) => {
                state.save_evolution_loading = false;
            })
            .addCase(adminSavePokemonEvolution.rejected, (state) => {
                state.save_evolution_loading = false;
            })
    }
});

export default pokemonSlice.reducer;
